module.exports = __webpack_public_path__ + "img/144.1.5715a885.jpg";